export default "__VITE_ASSET__BtO9f18H__"